export const PageType = {
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  PRIVACY_POLICY: 'privacy_policy',
  ABOUT_US: 'about_us',
  FAQ: 'faq',
  HELP_CENTER: 'help_center',
  REFUND_POLICY: 'refund_policy',
  CANCELLATION_POLICY: 'cancellation_policy',
  SHIPPING_POLICY: 'shipping_policy',
  CONTACT_US: 'contact_us',
  TRUST_AND_SAFETY: 'trust_and_safety',
  DELETE_ACCOUNT: 'delete_account',
  CUSTOM: 'custom',
  TERMS_AND_CONDITIONS_CUSTOMER: 'terms_and_conditions_customer',
  TERMS_AND_CONDITIONS_PROVIDER: 'terms_and_conditions_provider',
  SERVICE_PROVIDER_AGREEMENT: 'service_provider_agreement',
  OTHER_COMPLIANCE: 'other_compliance',
  DISCLAIMER: 'disclaimer',
  NOTE: 'note'
};

export const PageStatus = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};

export const Language = {
  ENGLISH: 'english',
  HINDI: 'hindi',
  MARWARI: 'marwari',
};

export const PAGE_TYPE_OPTIONS = [
  { value: 'terms_and_conditions', label: 'Terms & Conditions' },
  { value: 'privacy_policy', label: 'Privacy Policy' },
  { value: 'about_us', label: 'About Us' },
  { value: 'faq', label: 'FAQ' },
  { value: 'help_center', label: 'Help Center' },
  { value: 'refund_policy', label: 'Refund Policy' },
  { value: 'cancellation_policy', label: 'Cancellation Policy' },
  { value: 'shipping_policy', label: 'Shipping Policy' },
  { value: 'contact_us', label: 'Contact Us' },
  { value: 'trust_and_safety', label: 'Trust & Safety' },
  { value: 'delete_account', label: 'Delete Account' },
  { value: 'terms_and_conditions_customer', label: 'Terms and Conditions Customer' },
  { value: 'terms_and_conditions_provider', label: 'Terms and Conditions Provider' },

  { value: 'service_provider_agreement', label: 'Service Provider Agreement' },
  { value: 'other_compliance', label: 'Other Compliance' },
  { value: 'disclaimer', label: 'Disclaimer' },
  { value: 'note', label: 'Note' }

];

export const STATUS_OPTIONS = [
  { value: 'all', label: 'All Status' },
  { value: 'draft', label: 'Draft' },
  { value: 'published', label: 'Published' },
  { value: 'archived', label: 'Archived' },
];

export const LANGUAGE_TABS = [
  { key: 'english', label: 'English' },
  { key: 'hindi', label: 'हिंदी' },
  { key: 'marwari', label: 'मारवाड़ी' },
];

export const LANGUAGE_OPTIONS = [
  { value: 'english', label: 'English' },
  { value: 'hindi', label: 'हिंदी' },
  { value: 'marwari', label: 'मारवाड़ी' },
];
